export default function renderComponent(component, title) {
    document.title = title ? `PartsSource - ${title}` : 'PartsSource';
    return component;
}
